import React from 'react';
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from '../Tabs/Tabs';
import GroupContractPresenterTabContent from './GroupContractPresenterTabContent';
import { format, parseISO } from 'date-fns'
import DateHelper from '../DateHelper/DateHelper'

class GroupContractPresenter extends React.Component {

	constructor(props) {
		super(props)

		this.state = {
      active_tab: this.props.active_tab || 'general',

      errors: this.props.errors || [],
      id: this.props.id,
      code: this.props.code || '',
      name: this.props.name || '',
      description: this.props.description || '',
      status: this.props.status,
      maximum_stay: this.props.maximum_stay,
      minimum_stay: this.props.minimum_stay,
    
      
      date_format: this.props.date_format, 
      time_format: this.props.time_format, 
      check_in_time: this.props.check_in_time ? format(parseISO(this.props.check_in_time), DateHelper.rubyToDateFNS(this.props.time_format)) : '',
      check_out_time: this.props.check_out_time ? format(parseISO(this.props.check_out_time), DateHelper.rubyToDateFNS(this.props.time_format)) : '',
      end_date: this.props.end_date ? format(parseISO(this.props.end_date), DateHelper.rubyToDateFNS(this.props.date_format)) : null,
      start_date: this.props.start_date ? format(parseISO(this.props.start_date), DateHelper.rubyToDateFNS(this.props.date_format)) : null,
      
      group_contract_prices: this.props.group_contract_prices || [],
      group_contract_rates: this.props.group_contract_rates || [], 
      
      group_contract_notes_path: this.props.group_contract_notes_path,
      group_contract_revision_history_path: this.props.group_contract_revision_history_path
      
    }
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
 
  }
  
	render() {
    var self = this
    var buttons = [{
      name: I18n.t('ok'),
      html_attributes: [
        'data-dismiss="modal"'
      ]
    }]

		return (
			<div className="group-contract-builder" ref="root">
        <Tabs tabs={this.tabs()} />
				<div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <GroupContractPresenterTabContent {...this.state} />
        </div>
			</div>
		)
	}

  onChangeActiveTab(active_tab) {
    this.setState({active_tab: active_tab})
  };

  tabs(){
    if(this.props.history_hidden == true) {
      return ([
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]);
    } else {

      return ([
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('pricing'),
          targetName: 'pricing',
          classes: this.state.active_tab === 'pricing' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('rates'),
          targetName: 'rates',
          classes: this.state.active_tab === 'rates' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('notes'),
          targetName: 'notes',
          classes: this.state.active_tab === 'notes' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t('history'),
          targetName: 'history',
          classes: this.state.active_tab === 'history' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        }
      ]);
    }
  };

};

export default GroupContractPresenter;
